/** Etykiety i warianty chipów statusu zadania (ekran „Zadania i zlecenia"). */

import type { StatusVariant } from '@/design/components'
import type { TaskStatus } from './types'

export const STATUS_LABEL: Record<TaskStatus, string> = {
  open: 'Otwarte',
  in_progress: 'W realizacji',
  done: 'Zakończone',
  cancelled: 'Anulowane',
}

export const STATUS_VARIANT: Record<TaskStatus, StatusVariant> = {
  open: 'neutral',
  in_progress: 'warning',
  done: 'success',
  cancelled: 'neutral',
}

/** Statusy „otwarte" — dla nich lista pokazuje akcję „Zakończ". */
export const OPEN_STATUSES: TaskStatus[] = ['open', 'in_progress']

/** Kolejność w selectach (statusy zamykające na końcu). */
export const STATUS_OPTIONS: { value: TaskStatus; label: string }[] = (
  ['open', 'in_progress', 'done', 'cancelled'] as const
).map((value) => ({ value, label: STATUS_LABEL[value] }))
